var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6943 2H14.8848C14.4339 2 14.0685 2.36548 14.0685 2.81633C14.0685 3.26717 14.4339 3.63265 14.8848 3.63265H18.6943C19.4457 3.63265 20.0548 4.24179 20.0548 4.9932V8.80272C20.0548 9.25357 20.4203 9.61905 20.8712 9.61905C21.322 9.61905 21.6875 9.25357 21.6875 8.80272V4.9932C21.6875 3.3401 20.3474 2 18.6943 2Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6807 20.3673H8.49022C8.94107 20.3673 9.30655 20.7328 9.30655 21.1837C9.30655 21.6345 8.94107 22 8.49022 22H4.6807C3.0276 22 1.6875 20.6599 1.6875 19.0068V15.1973C1.6875 14.9056 1.84309 14.6361 2.09566 14.4903C2.34824 14.3445 2.65942 14.3445 2.91199 14.4903C3.16456 14.6361 3.32015 14.9056 3.32015 15.1973V19.0068C3.32015 19.7582 3.92929 20.3673 4.6807 20.3673Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0548 15.1984C20.0548 14.747 20.4203 14.381 20.8712 14.381C21.3178 14.3809 21.6815 14.7403 21.6875 15.1875V19.0025C21.6875 20.658 20.3474 22 18.6943 22H14.8848C14.4339 22 14.0685 21.634 14.0685 21.1825C14.0685 20.731 14.4339 20.365 14.8848 20.365H18.6943C19.4457 20.365 20.0548 19.755 20.0548 19.0025V15.1984Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6807 2H8.49022C8.94107 2 9.30655 2.36548 9.30655 2.81633C9.30655 3.26717 8.94107 3.63265 8.49022 3.63265H4.6807C3.92929 3.63265 3.32015 4.24179 3.32015 4.9932V8.80272C3.32015 9.25357 2.95467 9.61905 2.50383 9.61905C2.05298 9.61905 1.6875 9.25357 1.6875 8.80272V4.9932C1.6875 3.3401 3.0276 2 4.6807 2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.2add504eee4c2042dda035deb1403afc.svg";
export { ForwardRef as ReactComponent };